<template>
    <div class="input-group date vue-component">
        <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
        <input type="text" class="form-control" v-bind:value="value" v-bind:name="name" :disabled="disabled" :readonly="readonly">
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            name: String,
        },
        mounted() {
            let component = this;

            $(this.$el).datepicker({
                format: "mm/dd/yyyy",
                todayBtn: "linked",
                keyboardNavigation: false,
                forceParse: false,
                autoclose: true,
                todayHighlight: true
            }).on('change', this.$el, function($event) {
                component.$emit('input', $event.target.value);
            });
        }
    }
</script>
